<template>
  <el-dialog
    width="450px"
    :title="$t('productAdded.jumpRemind')"
    :visible.sync="dialogProductRuleVisible"
    :show-close="true"
  >
    <table>
      <tr v-for="(item,index) in productRuleList" :key="index">
        <td style="text-align: left; word-break: break-word">
          <span
            v-if="isSeries(item)"
            style="color: #00b1e7;font-weight: bold;"
            v-html="item"
          />
          <span
            v-else
            v-html="item"
          />
        </td>
      </tr>
    </table>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        @click="() => {dialogProductRuleVisible = false;
                       productRuleList=[]}"
      >
        {{ $t('homePage.takeAway') }}
      </el-button>
      <el-button type="primary" @click="toSecond">
        {{ $t('productAdded.continueJump') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from '../../api';
export default {
  name: 'ProductRuleList',
  data () {
    return {
      productRuleList: [],
      dialogProductRuleVisible: false
    };
  },
  components: {},
  props: {
    groupSubItemListVOS: {
      type: Array,
      default: null
    },
    projectId: {
      type: String,
      default: ''
    },
    groupId: {
      type: String,
      default: ''
    }
  },
  computed: {},
  methods: {
    isSeries (item) {
      return item.indexOf(' ：') !== -1;
    },
    getProductRuleList () {
      api.getProductRuleList(this.groupSubItemListVOS).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.productRuleList = json.data;
          if (this.productRuleList.length > 0) {
            this.dialogProductRuleVisible = true;
          }
        } else {
          this.toSecond();
        }
      }).catch(() => {
        this.$notify.error(`${this.$t('productAdded.networkAnomaly')}`);
      });
    },

    getAddValidateInfo () {
      api.getAddValidateInfo({ params: { 'groupId': this.groupId } }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.productRuleList = json.data;
          if (this.productRuleList.length > 0) {
            this.dialogProductRuleVisible = true;
          }
        } else {
          this.toSecond();
        }
      }).catch((e) => {
        console.log(e);
        this.$notify.error('网络异常');
      });
    },

    // 跳转至配置组
    toSecond () {
      this.$router.push({ name: 'CreatOrderSecond/second', query: { projectId: this.projectId } });
    }
  }
};
</script>

<style scoped>
  .el-icon-error{
    font-size: 20px;
    color: red;
  }

</style>
